import { axios } from 'shared/services/axios'

export function getGuidForCaptcha(flow, captcha) {
  return axios.post('/api/captcha', { flow, captcha })
    .then(response => response.data)
}
